import React from 'react'
import { Sidebar } from './Sidebar'
import { TopNavigation } from './TopNavigation'
import { SidebarProvider, useSidebar } from '@/contexts/SidebarContext'

interface LayoutProps {
  children: React.ReactNode
}

const LayoutInner: React.FC<LayoutProps> = ({ children }) => {
  const { isCollapsed } = useSidebar()
  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className={`flex-1 flex flex-col overflow-hidden transition-all ${isCollapsed ? 'ml-16' : 'ml-64'}`}>
        <TopNavigation />
        <main className="flex-1 overflow-auto p-6">{children}</main>
      </div>
    </div>
  )
}

export const Layout: React.FC<LayoutProps> = ({ children }) => (
  <SidebarProvider>
    <LayoutInner>{children}</LayoutInner>
  </SidebarProvider>
)